import { render, staticRenderFns } from "./newRosterFormRecord.vue?vue&type=template&id=476648a7&"
import script from "./newRosterFormRecord.vue?vue&type=script&lang=js&"
export * from "./newRosterFormRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('476648a7')) {
      api.createRecord('476648a7', component.options)
    } else {
      api.reload('476648a7', component.options)
    }
    module.hot.accept("./newRosterFormRecord.vue?vue&type=template&id=476648a7&", function () {
      api.rerender('476648a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Roster/RosterFormRecord/newRosterFormRecord.vue"
export default component.exports